module.exports = __webpack_public_path__ + "8439f1f2a62cf9674beee5b6637a1086.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/machismo.svg
// module id = 13
// module chunks = 0